import { IAppState } from '@myStore/app.state';
import { IGroupsViewState } from '@myStore/groups-view/groups-view.state';
import { createSelector } from '@ngrx/store';

const groupsViewSelector = (state: IAppState) => state.groupsView;

export const selectGroupDetailLoading = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.group.isLoading
);

export const selectGroupDetail = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.group.detail
);

export const selectLoadingGroupsList = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.isLoading
);

export const selectLoadingGroupsListErrors = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.errors
);

export const selectGroups = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.groups
);

export const selectCourseGroupsLoading = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.courseGroups.isLoading
);

export const selectCourseGroups = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.courseGroups.data
);

export const selectStudentsTransfersGroups = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.studentsTransfersGroups.data
);

export const selectStudentsTransfersGroupsLoading = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.studentsTransfersGroups.isLoading
);

export const selectUserAccessLoading = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.userAccess.isLoading
);

export const selectUserAccess = createSelector(
  groupsViewSelector,
  (state: IGroupsViewState) => state?.userAccess.data
);
